// Legal policies are DDD-wide: The Art of Story links to the central
// Dive Deep Dialogues versions rather than keeping its own copies (the
// Relationship Compass pattern). The in-app /privacy page is only this
// app's data details and privacy settings.
export const DDD_TERMS_URL = 'https://divedeepdialogues.com/terms';
export const DDD_PRIVACY_URL = 'https://divedeepdialogues.com/privacy';
export const DDD_COOKIES_URL = 'https://divedeepdialogues.com/cookies';
